export const STATUS_COLOR = {
  WAITING: 'brand.orange.primary',
  SUCCESS: 'brand.green.primary',
  ACTIVE: 'brand.blue.primary',
};

export const OPERATION_STATUS = {
  WaitForCheck: {
    color: STATUS_COLOR.WAITING,
    label: 'منتظر تایید',
  },
  Done: {
    color: STATUS_COLOR.SUCCESS,
    label: 'تایید شد',
  },
  done: {
    color: STATUS_COLOR.SUCCESS,
    label: 'انجام شده',
  },
  InProsses: {
    color: STATUS_COLOR.ACTIVE,
    label: 'درحال جمع آوری',
  },
  Pending: {
    color: STATUS_COLOR.ACTIVE,
    label: 'به PDA ارسال شد',
  },
  pending: {
    color: STATUS_COLOR.ACTIVE,
    label: 'در انتظار',
  },
  PreView: {
    color: STATUS_COLOR.ACTIVE,
  },
};
